import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./app/router.js";
import { initSentryClient } from "./shared/observability/sentry.js";
import { currentLocale } from "./i18n/index.js";
import "./index.css";
import {
  SaasThemeProvider,
  applySaasThemeToDocument,
  installTouchFocusGuard,
  normalizeStoredTheme,
  resolveSaasTheme,
} from "@bube/ui-design-system";

// HQ-2026-009 — sớm nhất có thể; không có `VITE_SENTRY_DSN` thì không làm gì (SDK không được tải).
initSentryClient();

/** Màn cảm ứng: mở trang / biểu mẫu / ô chọn không tự bật bàn phím ảo — xem `utils/touch-autofocus.ts` của UDS. */
installTouchFocusGuard();

/**
 * HQ-2026-006 — theme của design system, mặc định THEO HỆ THỐNG. Áp ngay trước `render()` để lần vẽ đầu đã đúng màu
 * (provider chỉ đọc `localStorage` sau khi mount).
 */
const THEME_STORAGE_KEY = "hq-theme";
let storedTheme: string | null = null;
try {
  storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
} catch {
  // localStorage bị chặn — theo hệ thống.
}
applySaasThemeToDocument(document.documentElement, resolveSaasTheme(normalizeStoredTheme(storedTheme, "system")));
document.documentElement.lang = currentLocale();

const root = document.getElementById("root");
if (!root) throw new Error("Không tìm thấy #root trong index.html");

createRoot(root).render(
  <StrictMode>
    <SaasThemeProvider defaultTheme="system" storageKey={THEME_STORAGE_KEY}>
      <RouterProvider router={router} />
    </SaasThemeProvider>
  </StrictMode>,
);
